import { Link } from 'react-router'

export const MarkdownLink = ({ href, title = '', children }: {href: string, title?: string, children?: React.ReactNode}) => <Link to={href} title={title}>{children}</Link>